export const ORANGE = 'orange darken-2';
export const PRIMARY = 'blue lighten-2';
